export const DOCS_AND_GUIDES_URL = 'https://help.liftai.com';
export const DOCS_AND_GUIDES_LABEL = 'Docs & Guides';
